import useAppTranslation from "@hooks/language/useAppTranslation";
import SSBadge from "./Badge";
import Icon from "./icon/Icon";

const PopularBadge = () => {
  const { t } = useAppTranslation("components.popularBadge");
  return (
    <SSBadge
      color={{
        background:
          "linear-gradient(93deg, rgba(255,180,0,0.7) 0%, rgba(255,180,0,0.5) 100%)",
        text: "#FFEA00",
        border: "#FFC300",
      }}
      leftSection={<Icon.Fire size={20} className="w-16" />}
    >
      {t("label")}
    </SSBadge>
  );
};

export default PopularBadge;
